import { formatCurrency } from './formatNumber';

/**
 * Building limit bounds come from the options endpoint via useGetApplicationOptions, which
 * already resolves the feUseDynamicBopLimits flag. Both editors share this so the message
 * copy and the no-bounds behavior cannot drift between them.
 *
 * Returns null when the value is acceptable, and also when the endpoint gave us no bounds to
 * check against — there is no local fallback to fall back to, so the value passes.
 */
export const getBuildingLimitErrorMessage = (
  value: number | undefined,
  buildingLimitMin: number | undefined,
  buildingLimitMax: number | undefined
): string | null => {
  if (value == null) return null;
  if (buildingLimitMin == null || buildingLimitMax == null) return null;
  if (value > buildingLimitMax) return `Coverage cannot be greater than ${formatCurrency(buildingLimitMax)}`;
  if (value < buildingLimitMin) return `Coverage cannot be less than ${formatCurrency(buildingLimitMin)}`;

  return null;
};
